import { Utility } from './../../utility/util';

import { IONote } from '../io/io-note.class';
import { Opportunity } from '../opportunity-management/opportunity.class';
import { EventActivity } from '../events-tool/event.class';

export class MarketingPlan {
  public ID: string;
  public brandPlanName: string;
  public startDate: string;
  public endDate: string;
  public accountId: string;
  public accountName: string;
  public parentAccountId: string;
  public state: number;
  public status: string;
  public statusCode: any;
  public brandPlanTimeFrame: string;
  public products: any[];
  public lastUpdated: number;
  public ownerID: string;
  public ownerName:string;
  public estimatedRevenue: number;
  public estimatedRevenureFormatted: string;
  public actualRevenue: number;
  public actualRevenueFormatted: string;
  public indskr_totalbudget: number;
  public currencyId: string;
  public currencyName: string;
  public plannedBudgetFormatted: string;
  public contactAccountAffs: any[];
  public events: EventActivity[];
  public accounts: Account[];
  public contacts: any;
  // public notes: IONote[];
  public MarketingPlansNotes: Array<IONote> = [];
  public opportunities: Opportunity[];
  public parentMarketingBusinessPlanId : string;
  public parentMarketingBusinessPlanName : string;
  public associationBusinessUnits: any[];
  public focusArea: string;
  public createdOnString: string;
  public primarySpecialtyId:string;
  public primarySpecialtyName:string;
  public subSpecialtyId:string;
  public subSpecialtyName:string;
  public type:string;
  public typeFormatted:string;
  public purpose:number;
  public purposeFormatted:string;
  public hierarchyOpportunityConversionRate:number;
  public opportunityConversionRate:number;
  public hcpTrainingCompleted:boolean;
  public multiyearCampaign:boolean;
  public npiApprovedByAccount:boolean;
  public npiProcessStarted:boolean;
  public createdByString:string;
  public lastModifiedByString:string;

  constructor(raw: JSON) {
    this.brandPlanName = raw['indskr_name'] || '';
    this.ID = raw['indskr_brandplanid'];
    this.startDate = raw['indskr_validfrom'] ? Utility.changeUTCDateToLocalDateWith0Time(new Date(raw['indskr_validfrom']).getTime()).getTime().toString() : '';
    this.endDate = raw['indskr_validto'] ? Utility.changeUTCDateToLocalDateWith0Time(new Date(raw['indskr_validto']).getTime(), true).getTime().toString() : '';
    this.accountName = raw['account.name'];
    this.parentAccountId = raw['account.parentaccountid'] || '';
    this.accountId = raw['account.accountid'];

    this.state = raw['statecode'] || 0;
    this.statusCode = raw['statusCode'] || 1
    this.status = raw['statuscode'] && raw['statuscode'] == 548910001 ? 'Completed' : raw['statuscode'] && raw['statuscode'] == 2 ? 'Inactive' : raw['statuscode'] && raw['statuscode'] == 548910002 ? 'Cancelled' : 'Open';
    this.products = [];
    // this.trackAction = raw['track_action@OData.Community.Display.V1.FormattedValue'] ? raw['track_action@OData.Community.Display.V1.FormattedValue'] : '';
    this.brandPlanTimeFrame = Utility.changeUTCDateToLocalDateWith0Time(new Date(raw['indskr_enddate']).getTime(), true).getTime() < Date.now() ? 'Past'
      : Utility.changeUTCDateToLocalDateWith0Time(new Date(raw['indskr_startdate']).getTime()).getTime() > Date.now() ? 'Future' : 'Present';
    this.ownerID = raw['_ownerid_value'] || '';
    this.ownerName = raw['ownerid_value@OData.Community.Display.V1.FormattedValue'] || '';
    this.estimatedRevenue = raw['indskr_estimatedrevenuetotal'] || 0.00;
    this.estimatedRevenureFormatted = raw['indskr_estimatedrevenuetotal@OData.Community.Display.V1.FormattedValue'] || '0.00';
    this.actualRevenue = raw['indskr_actualrevenuetotal'] || 0.00;
    this.actualRevenueFormatted = raw['indskr_actualrevenuetotal@OData.Community.Display.V1.FormattedValue'] || '0.00';
    this.indskr_totalbudget = raw['indskr_totalbudget'] || 0.00;
    this.plannedBudgetFormatted = raw['indskr_totalbudget@OData.Community.Display.V1.FormattedValue'] || '0.00';
    this.currencyId = raw['transactioncurrencyid_value'] || raw['transactionCurrecnyId'] || ''
    this.currencyName = raw['transactioncurrencyid_value@OData.Community.Display.V1.FormattedValue'] || ''
    this.contactAccountAffs = [];
    this.events = [];
    this.opportunities = [];
    this.accounts = [];
    this.contacts = [];
    this.focusArea = raw['indskr_focusarea'] || '';
    this.associationBusinessUnits = [];
    this.primarySpecialtyId = raw['indskr_primaryspecialty_value'] || '';
    this.primarySpecialtyName = raw['indskr_primaryspecialty_value_Formatted'] || '';
    this.subSpecialtyId = raw['indskr_subspecialty_value'] || '';
    this.subSpecialtyName = raw['indskr_subspecialty_value_Formatted'] || '';
    this.type = raw['indskr_type_value'] || '';
    this.typeFormatted = raw['indskr_type_value_Formatted'] || '';
    this.purpose = raw['indskr_purpose'] || '';
    this.purposeFormatted = raw['indskr_purpose@OData.Community.Display.V1.FormattedValue'] || '';
    this.hierarchyOpportunityConversionRate = raw['indskr_hierarchyopportunityconversionrates'] || null;
    this.opportunityConversionRate = raw['indskr_opportunityconversionrates'] || null;
    this.hcpTrainingCompleted = raw.hasOwnProperty('indskr_hcptrainingcompleted') ? raw['indskr_hcptrainingcompleted'] : null;
    this.multiyearCampaign = raw.hasOwnProperty('indskr_multiyearcampaign') ?raw['indskr_multiyearcampaign'] : null;
    this.npiApprovedByAccount = raw.hasOwnProperty('indskr_npiapprovedbyaccount') ? raw['indskr_npiapprovedbyaccount'] : null;
    this.npiProcessStarted = raw.hasOwnProperty('indskr_npiprocessstarted') ? raw['indskr_npiprocessstarted'] : null;
    this.createdByString = raw['createdby_value@OData.Community.Display.V1.FormattedValue'] || '';
    this.lastModifiedByString = raw['modifiedby_value@OData.Community.Display.V1.FormattedValue'] || '';
  }

  get planID() {
    return this.ID;
  }

}
export class Account {
  constructor(public id: string,
    public name: string,
    public statecode: number) { }
}

export class Contact {
  constructor(public id: string,
    public name: string,) { }
}

export class Currency {
  public id: string;
  public symbol: string;
  public name: string;
  public code: string;
  constructor(raw:JSON) {
    this.id = raw['transactioncurrencyid'],
    this.symbol = raw['currencysymbol'],
    this.name = raw['currencyname']
    this.code = raw['isocurrencycode'];
   }
}

export enum CurrencySymbolInHtml {
  'US Dollar' = '$',
  'Rupee' = '&#8377;',
  'Pound' = '&#163;',
}

export enum accounPlanObjectiveType {
  type_548910000 = 'QUANTITATIVE',
  type_548910001 = 'QUALITATIVE'
}

export enum MarketingPlanPurpose {
  SALES = 548910000,
  EDUCATION = 548910001,
  RISK = 548910002,
}

